export default __webpack_public_path__ + "static/media/d9.0986f5a7.png";